export interface SlackSettings {
  "slack-app-token": string | null;
  "slack-files-channel": string | null;
  "slack-bug-report-channel": string | null;
}
